import { GetTemplateMessage, GetTemplateMessageVariables } from './__generated__/GetTemplateMessage'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query GetTemplateMessage($templateMessageV2Id: String!) {
    templateMessage: templateMessageV2(id: $templateMessageV2Id) {
      ... on TemplateMessageV2 {
        id
        isFeatured
        attribution
        categoryId
        created
        message {
          id
          characters
          text
          tags
          cardSize
        }
      }
      ... on TemplateMessageErrorV2 {
        type
        error
      }
    }
  }
`

export const useGetTemplateMessage = (id: string) => {
  return useQuery<GetTemplateMessage, GetTemplateMessageVariables>(QUERY, {
    variables: {
      templateMessageV2Id: id
    }
  })
}
